var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal modal-filter-details fade",
      attrs: {
        id: "modal-edit-due-date" + "" + _vm.paymentId,
        role: "dialog",
        "aria-labelledby": "location-label",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body col-xs-12" }, [
            _c(
              "div",
              { staticClass: "col-sm-4 col-sm-offset-4" },
              [
                _c("flatpickr", {
                  key: _vm.paymentId,
                  staticClass: "form-control pickdate",
                  attrs: {
                    id: _vm.paymentId,
                    config: _vm.flatPickerSingleDateConfig,
                    placeholder: "Please select a date",
                    name: "date",
                  },
                  model: {
                    value: _vm.selectedDate,
                    callback: function ($$v) {
                      _vm.selectedDate = $$v
                    },
                    expression: "selectedDate",
                  },
                }),
                _vm._v(" "),
                _vm.previous !== _vm.selectedDate
                  ? _c("p", [
                      _vm._v(
                        "Previously " +
                          _vm._s(
                            _vm._f("date")(
                              _vm.previous,
                              _vm.$user.date_format_preference
                            )
                          )
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: { click: _vm.handleSaveDueDateCallback },
              },
              [_vm._v("Save")]
            ),
            _vm._v(" "),
            _vm._m(1),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h4",
        { staticClass: "modal-title", attrs: { id: "location-label" } },
        [_vm._v("Edit Payment Due Date")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-danger",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [_c("i", { staticClass: "fa fa-close" }), _vm._v(" Close Without Saving")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }